var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nurse-table',{attrs:{"canDelete":true,"viewRoute":"FranchiseNurseDetails","canCreate":true,"createRoute":"FranchiseNurseCreate","viewDetailRoute":"FranchiseNurseDetailView","canAssignClinic":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }